var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmedtrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0148 24.5777H22.1179C21.8826 24.5777 21.6702 24.7107 21.5771 24.9157L19.0942 30.4081L24.9908 27.547C24.2849 26.6191 23.5866 25.5957 23.0148 24.5777Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4227 24.9157C34.3298 24.7107 34.1172 24.5777 33.8821 24.5777H32.9852C31.9055 26.4998 30.3325 28.4862 29.3318 29.579C28.6281 30.3459 27.371 30.345 26.6684 29.579C26.5965 29.5006 26.2213 29.0879 25.7045 28.4533L24.6414 28.9693L28.6627 32.7822L36.2823 29.0295L34.4227 24.9157Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3688 32.0132L18.0481 32.7227C17.882 33.0899 18.1665 33.5 18.5887 33.5H27.2235C27.2775 33.4619 27.2781 33.4642 27.568 33.3214L23.5408 29.5035L18.3688 32.0132Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9519 32.7227L36.7471 30.0575L29.7574 33.5H37.4113C37.8326 33.5 38.1183 33.0906 37.9519 32.7227Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5882 19.5218C28.5882 19.2142 28.3243 18.9642 28 18.9642C27.6756 18.9642 27.4118 19.2142 27.4118 19.5218C27.4118 19.8293 27.6756 20.0795 28 20.0795C28.3243 20.0795 28.5882 19.8293 28.5882 19.5218Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4439 28.81C28.642 28.594 33.2939 23.4819 33.2939 19.9678C33.2939 12.7217 22.7061 12.6332 22.7061 19.9678C22.7061 23.4819 27.3581 28.594 27.5561 28.81C27.7907 29.0656 28.2098 29.0653 28.4439 28.81ZM26.2353 19.5218C26.2353 18.5993 27.027 17.8488 28 17.8488C28.9729 17.8488 29.7645 18.5993 29.7645 19.5218C29.7645 20.4442 28.9729 21.1946 28 21.1946C27.027 21.1946 26.2353 20.4442 26.2353 19.5218Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedtrip);
export default __webpack_public_path__ + "static/media/confirmedtrip.044bed84afe5f1e8861ff204dddbc1db.svg";
export { ForwardRef as ReactComponent };